import { render, staticRenderFns } from "./SectionAdvantages.vue?vue&type=template&id=360c0b81&scoped=true&"
import script from "./SectionAdvantages.vue?vue&type=script&lang=js&"
export * from "./SectionAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./SectionAdvantages.vue?vue&type=style&index=0&id=360c0b81&scoped=true&lang=scss&"
import style1 from "./SectionAdvantages.vue?vue&type=style&index=1&id=360c0b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c0b81",
  null
  
)

export default component.exports